import {Component, OnInit} from '@angular/core';
import {AuthService} from "../auth.service";
import {Router} from "@angular/router";
import {Auth} from "../app.auth";

@Component({
    selector: 'app-signout',
    template: '<loader></loader>',
    styleUrls: ['./signout.component.css']
})
export class SignOutComponent implements OnInit {

    constructor(private _authService: AuthService,
                private _auth: Auth,
                private _router: Router) {
    }

    ngOnInit() {
        this._authService
            .signOut()
            .subscribe(
                () => {
                    this._auth.authToken = "";
                    this._auth.user = null;
                },
                null,
                () => this._router.navigate(["/"]))
    }
}



// WEBPACK FOOTER //
// ./src/app/signout/signout.component.ts